import { fetchUserFromStorage } from './registration'
import { get } from './config'
import * as moment from 'moment'
import { _ } from 'underscore';

const StoryblokClient = require('storyblok-js-client');

const CONTENT_PATH = 'channels/digital-passport/passport/offers-application-page-content';
const TOURISAM_PATH = 'channels/digital-passport/passport/tourism-partners';
const CATEGORY_PATH = 'foundations/category';
const OFFER_PATH = 'channels/digital-passport/passport/offers/';

const getClient = (token) => {
    return new StoryblokClient({
        accessToken: token,
        cache: {
            clear: 'auto',
            type: 'memory'
        }
    }, 'https://app.storyblok.com/v1')
}

const getStories = async (starts_with, options) => {
    const {
        token = get('storyblokAccessToken'),
        per_page = 100,
        page = 1,
        resolve_relations = '',
        locale = undefined,
        filter_query = '',
        by_uuids = [] } = options || {}

    const storyBlokClient = getClient(token)

    // Get cache version from space
    const space = await storyBlokClient.get('cdn/spaces/me')
    const cv = space.data.space.version

    const startsWith = locale !== 'en-au' ? `${locale}/${starts_with}` : starts_with

    const response = await storyBlokClient.get('cdn/stories', {
        starts_with: startsWith,
        cv,
        resolve_relations,
        per_page,
        page,
        filter_query,
        by_uuids
    })

    return response
}

const list = async (starts_with, options) => {
    const { per_page = 25 } = options || {}

    const firstPage = await getStories(starts_with, { per_page, ...options });

    const totalPages = Math.ceil(firstPage.headers['total'] / per_page)

    if (totalPages <= 1)
        return firstPage.data.stories

    const promises = []
    let page = 2;

    while (totalPages && page && page <= totalPages) {
        promises.push(getStories(starts_with, { page, per_page, ...options }));
        page = page + 1;
    }

    const responses = await Promise.all(promises);

    const output = responses.reduce((output, x) => output.concat(x.data.stories), firstPage.data.stories);
    return output;
}

const getContent = async () => {
    return getStories(CONTENT_PATH, { resolve_relations: 'theme', locale: getLocale() })
}

const getTourismPartner = async () => {
    return getStories(TOURISAM_PATH, { locale: getLocale() })
}

const getSuperCategories = async () => {
    return list(CATEGORY_PATH, { resolve_relations: 'sub-category', locale: getLocale() })
}

const getOffers = async () => {
    const offers = await list(OFFER_PATH, { resolve_relations: 'store', locale: getLocale() })
    return offers.filter(offer => offer.content.store !== null)
}

const getLocale = () => {
    const userData = fetchUserFromStorage()

    if (userData) {
        return userData.locale
    }

    let params = new URLSearchParams(document.location.search)
    return params.get('locale')
}

const retrieveStores = (offers) => {
    const stores = offers
                    .map(offer => offer.content.store)
                    .filter((value, index, self) => self.findIndex(store => store.content.retailer.retailer === value.content.retailer.retailer) === index)

    return stores;
}

const retrieveRetailers = (stores) => {
    const retailers = stores.map(store => {
        return {
            logo: store.content.logo.url || store.content.logo,
            slug: store.slug,
            name: store.name,
            uuid: store.content.retailer.retailer
        }
    })

    return retailers;
}

const retrieveTheme = (contentCollection) => {
    const theme = contentCollection.data.stories[0].content.theme.content;

    return {
        ...theme,
        centreLogoPrimary: theme.centreLogoPrimary[0],
        centreLogoSecondary: theme.centreLogoSecondary[0],
        diningIcon: theme.diningIcon[0],
        entertainmentIcon: theme.entertainmentIcon[0],
        loadingLogo: theme.loadingLogo[0],
        redeemLogo: theme.redeemLogo[0],
        redeemStamp: theme.redeemStamp[0],
        shoppingIcon: theme.shoppingIcon[0]
    }
}

const retrievePageContent = (contentCollection) => {
    return contentCollection.data.stories[0].content;
}

const retrieveTourismOffers = (contentCollection) => {
    return contentCollection.data.stories;
}

const retrieveOffers = (offers) => {
    return offers.map((offer) => {
        return {
            ...offer.content,
            id: offer.uuid,
            validFrom: offer.content.validFrom ? moment(offer.content.validFrom).format('YYYY-MM-DD') : "",
            validTo: offer.content.validTo ? moment(offer.content.validTo).format('YYYY-MM-DD') : ""
        }
    })
}

export {
    retrieveOffers,
    retrieveTheme,
    retrieveStores,
    retrieveTourismOffers,
    retrievePageContent,
    retrieveRetailers,
    getSuperCategories,
    getTourismPartner,
    getContent,
    getStores,
    getOffers,
    getRetailers
}



// WEBPACK FOOTER //
// ./lib/storyBlok.js